package com.bikompanion.domain

/**
 * A network that might be the one a rider is standing in, and how far off it looks.
 *
 * [distanceKm] is to the nearest part of the network that is actually known — a dock when
 * [BikeNetwork.coverage] is populated, the network's single published centre point otherwise.
 * Those two are not comparable in any strict sense, which is why this is only ever used to rank
 * and to apply a generous cut-off, never to claim a rider is *in* a network.
 */
data class NetworkScopeCandidate(
    val network: BikeNetwork,
    val distanceKm: Double,
)
